import { Book, Chapter } from '../../../types';
import './chapter-index.css';
import { useLocation, Link } from 'wouter';

interface ChapterIndexProps {
  chapters: Chapter[];
  chapter: Chapter;
  book: Book;
}

export const ChapterIndex = ({
  chapters,
  chapter: currentChapter,
  book,
}: ChapterIndexProps) => {
  // Get current location to extract sidebar state
  const [location] = useLocation();
  
  // Check if we have a sidebar state in the URL
  let sidebarState = null;
  const pathParts = location.split('/');
  if (pathParts.length > 5) {
    const lastPart = pathParts[5];
    if (lastPart === 'comments') {
      sidebarState = 'comments';
    } else if (lastPart === 'chapter-list') {
      sidebarState = 'chapterList';
    } else if (lastPart === 'settings') {
      sidebarState = 'settings';
    }
  }
  return (
    <nav class="chapter-index">
      <ul>
        {chapters.map((chapter) => (
          <li>
            <Link
              href={
                sidebarState === 'chapterList' ? `/f/${book.permalink}/c/${chapter.permalink}/chapter-list` :
                sidebarState === 'comments' ? `/f/${book.permalink}/c/${chapter.permalink}/comments` :
                sidebarState === 'settings' ? `/f/${book.permalink}/c/${chapter.permalink}/settings` :
                `/f/${book.permalink}/c/${chapter.permalink}`
              }
              className={chapter.id === currentChapter.id ? 'active' : ''}
            >
              {chapter.title}
            </Link>
            {chapter.isPremium && (
              <span className="premium">(Premium Chapter)</span>
            )}

            {chapter.isDraft && <span className="draft">(Draft Chapter)</span>}
          </li>
        ))}
      </ul>
    </nav>
  );
};
